import { Box, Typography, Button, Paper } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { errorFallbackStyles as styles } from "./ErrorFallback.styles";
import { ROUTES } from "../../../routes";

export default function ErrorFallback({ error, onRetry }) {
  const { t } = useTranslation();

  return (
    <Box sx={styles.container}>
      <Paper elevation={3} sx={styles.paper}>
        <Typography variant="h5" color="error" sx={styles.title}>
          {t("errorBoundary.title", "Something went wrong")}
        </Typography>

        <Typography variant="body1" sx={styles.message}>
          {t(
            "errorBoundary.message",
            "We're sorry, but something unexpected happened. Please try refreshing the page."
          )}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<Refresh />}
          onClick={() => (window.location.href = ROUTES.PROJECTS)}
          sx={styles.retryButton}
        >
          {t("errorBoundary.retryButton", "Try Again")}
        </Button>

        <Box component="pre" sx={styles.debugContainer}>
          {error?.toString()}
        </Box>
      </Paper>
    </Box>
  );
}
